export const PATTERN = "000.000.000-00";

/**
 * gov.br / Receita Federal display convention: hides the first 3 digits and the 2 check
 * digits, e.g. "***.456.789-**".
 */
export const OBFUSCATED_PATTERN = "***.000.000-**";
